import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BusinessHomepage from './Pages/BusinessHomepage';
import ServicesPage from './Pages/ServicesPage';
import SolutionsPage from './Pages/SolutionsPage';
import PricingPage from './Pages/PricingPage';
import AboutPage from './Pages/AboutPage';
import ContactPage from './Pages/ContactPage';
import PrivacyPolicyPage from './Pages/PrivacyPolicyPage';
import TermsOfServicePage from './Pages/TermsOfServicePage';
import CookiePolicyPage from './Pages/CookiePolicyPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<BusinessHomepage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
